import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import _ from 'lodash';
import { Card, Input, Search, Divider, Icon, Loader, Message } from 'semantic-ui-react';

import FacebookLinkedMC from '../facebook-linked-mc';

import hasRESTClient from '../../hocs/has-rest-client';
import hasUserInfo from '../../hocs/has-user-info';

const marginTop10 = {
  marginTop: 10,
};

class FacebookMarketingCampaignLinker extends Component {
  constructor() {
    super();
    this.state = {
      noCampaignsOnFacebook: false,
      marketingCampaigns: [],
      existingCampaigns: [],
      loading: true,
      inputValue: '',
      failedToFetch: false,
    };
  }

  async componentDidMount() {
    const { restClient, buildRESTClient, userInfo: { organisationId }, campaignId } = this.props;
    const shareAPIClient = buildRESTClient({
      baseURL: process.env.REACT_APP_REPORT_API_URL,
      hasToken: true,
      timeout: 20000,
    });

    const campaignResponse = await restClient.get(`campaigns/${campaignId}`).catch(this.handleAPIError);
    const response = await shareAPIClient.get(`/marketing/organisation-mcs/by-id/${organisationId}`).catch(this.handleAPIError);

    if (!campaignResponse || !response) {
      return;
    }

    const existingCampaigns = _.get(campaignResponse, 'data.data.attributes.marketingCampaigns', []);
    const marketingCampaigns = _.get(response, 'data.data.marketingCampaigns', []);

    const filteredMarketingCampaigns = _.filter(
      marketingCampaigns,
      mc => _.isUndefined(_.find(existingCampaigns, ['id', mc.id])),
    );

    this.setState({
      marketingCampaigns: filteredMarketingCampaigns,
      existingCampaigns,
      loading: false,
      noCampaignsOnFacebook: _.isEmpty(marketingCampaigns),
    });
  }

  handleAPIError = () => {
    this.setState({
      loading: false,
      failedToFetch: true,
    });
  }

  onSearchChange = (event, { value }) => {
    this.setState({
      inputValue: value,
    });
  };

  link = async (event, { result: { id } }) => {
    const { restClient, campaignId } = this.props;
    const { marketingCampaigns, existingCampaigns } = this.state;
    const selectedMarketingCampaign = _.find(marketingCampaigns, ['id', id]);
    const newCampaigns = _.concat(existingCampaigns, [selectedMarketingCampaign]);
    await restClient.patch(`campaigns/${campaignId}`, {
      data: {
        attributes: {
          marketingCampaigns: newCampaigns,
        },
      },
    });
    this.setState({
      inputValue: '',
      existingCampaigns: newCampaigns,
      marketingCampaigns: _.reject(marketingCampaigns, ['id', selectedMarketingCampaign.id]),
    });
  }

  unlink = async mcId => {
    const { restClient, campaignId } = this.props;
    const { existingCampaigns, marketingCampaigns } = this.state;
    const unlinkedCampaign = _.find(existingCampaigns, ['id', mcId]);
    const newExistingCampaigns = _.reject(existingCampaigns, ['id', mcId]);
    const newMarketingCampaigns = _.concat(marketingCampaigns, [unlinkedCampaign]);
    await restClient.patch(`campaigns/${campaignId}`, {
      data: {
        attributes: {
          marketingCampaigns: newExistingCampaigns,
        },
      },
    });
    this.setState({
      existingCampaigns: newExistingCampaigns,
      marketingCampaigns: newMarketingCampaigns,
    });
  }

  render() {
    const {
      loading,
      marketingCampaigns,
      inputValue,
      failedToFetch,
      existingCampaigns,
      noCampaignsOnFacebook,
    } = this.state;

    const canRenderCampaigns = !loading && !failedToFetch;
    const noCampaignsYet = !loading && !failedToFetch && _.isEmpty(existingCampaigns);

    const allOptions = _.map(marketingCampaigns, item => ({
      id: item.id,
      title: item.name,
    }));

    const options = _.filter(
      allOptions,
      option => _.includes(_.lowerCase(option.title), _.lowerCase(inputValue)),
    );

    return (
      <div style={marginTop10}>
        <h3>
         Link a Facebook Ad Campaign
        </h3>
        {
          loading && <div><Loader inline active /></div>
        }
        {
          failedToFetch && (
            <Message warning>Something went wrong <Icon name="frown" /> <br />Please try again later.</Message>
          )
        }
        {
          canRenderCampaigns && (
            <div>
              {
                noCampaignsOnFacebook ? <div>no ad campaigns linked to this account</div> : (
                  <Search
                    fluid
                    input={<Input fluid />}
                    placeholder="search for facebook ad campaign..."
                    results={options}
                    style={marginTop10}
                    loading={loading}
                    disabled={loading || failedToFetch}
                    value={inputValue}
                    onResultSelect={this.link}
                    onSearchChange={this.onSearchChange}
                  />
                )
              }
              <Divider />
              <h3>Linked Campaigns</h3>
              {
                noCampaignsYet && <p>no linked campaigns yet.</p>
              }
              <Card.Group style={marginTop10} itemsPerRow="one">
                { _.map(existingCampaigns, item => <FacebookLinkedMC onUnlink={this.unlink} key={item.id} {...item} />) }
              </Card.Group>
            </div>
          )
        }
      </div>
    );
  }
}

FacebookMarketingCampaignLinker.propTypes = {
  campaignId: PropTypes.string.isRequired,
};

export default compose(
  hasRESTClient,
  hasUserInfo,
)(FacebookMarketingCampaignLinker);



/** WEBPACK FOOTER **
 ** ./src/components/facebook-marketing-campaign-linker/index.js
 **/